import React from 'react';
import * as Sentry from '@sentry/react';

/**
 * App-level error boundary. Renders a clean fallback when an uncaught error
 * crashes a render. Sentry captures the error + component stack via
 * `Sentry.ErrorBoundary` (no-op when DSN is unset).
 */
function ErrorFallback() {
  return (
    <div
      data-testid="app-error-fallback"
      className="min-h-screen w-full bg-[#0A0A0A] text-white flex items-center justify-center px-6"
    >
      <div className="max-w-md text-center space-y-4">
        <div className="text-6xl">⚡️</div>
        <h1 className="text-2xl font-bold tracking-tight">Something went off-script.</h1>
        <p className="text-sm text-gray-400">
          We hit an unexpected error and our engineers have been notified. You can try refreshing.
        </p>
        <button
          onClick={() => window.location.reload()}
          data-testid="error-reload-btn"
          className="mt-2 px-5 py-2.5 rounded-lg bg-[#FF4D94] hover:brightness-110 text-sm font-bold transition"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}

export default function AppErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
